import {useSelector} from 'react-redux';
import i18n from 'i18next';
import {loadedPresentationSelector} from '../store/selectors/presentation.selectors';

export function usePlayerLabels(): (code: string) => string | undefined {
    const loadedPresentation = useSelector(loadedPresentationSelector);

    return (code: string): string | undefined => {
        const label = loadedPresentation?.languageConfig?.labels?.find((label) => label.code === code);
        if (label) {
            return (label as never)[`${i18n.language}`];
        }
        return undefined;
    };
}
